import { render, staticRenderFns } from "./OtherEdit.vue?vue&type=template&id=50c2d373&scoped=true&"
import script from "./OtherEdit.vue?vue&type=script&lang=js&"
export * from "./OtherEdit.vue?vue&type=script&lang=js&"
import style0 from "./OtherEdit.vue?vue&type=style&index=0&id=50c2d373&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2d373",
  null
  
)

export default component.exports